<!-- Sfondo bianco pieno, modale OTP centralizzata -->
<div style="min-height: 100vh; background: #ffffff; display: flex; align-items: center; justify-content: center;">

	@if (loading()) {
		<div class="text-center">
			<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"></div>
			<p class="mt-3 text-muted">Caricamento in corso...</p>
		</div>

	} @else if (errorMsg() && !loadingAction()) {
		<div class="modal-otp-custom-box text-center p-5">
			<i class="bi bi-exclamation-circle-fill text-danger" style="font-size: 3rem;"></i>
			<h5 class="mt-3 fw-bold text-danger">Errore</h5>
			<p class="text-muted mt-2">{{ errorMsg() }}</p>
			<button class="btn btn-outline-danger mt-4 px-4 py-2 fw-bold" (click)="reload()">
				<i class="bi bi-arrow-clockwise me-2"></i>
				RICARICA PAGINA
			</button>
		</div>

	} @else {
		<!-- Box modale OTP custom -->
		<div class="modal-content modal-otp-custom-box" style="max-width: 480px; width: 100%; margin: auto; border-radius: 16px; box-shadow: 0 8px 40px rgba(0,0,0,0.12);">
			<div class="modal-body p-xl-5 p-4 position-relative text-center">

				<div class="mb-4">
					<h2 class="fw-bold mb-3">Verifica codice</h2>
					<p class="text-muted mb-2">
						Un codice a 6 cifre è stato inviato al numero di cellulare
						<strong>{{ phone() }}</strong>
					</p>
					@if (operationID()) {
						<p class="text-muted small mb-0">
							Riferimento operazione: <strong>{{ operationID() }}</strong>
						</p>
					}
				</div>

				<div class="mb-2">
					<span class="text-primary fw-bold" style="font-size: 14px;">Codice OTP</span>
				</div>

				<div class="otp-input-container d-flex justify-content-center align-items-center gap-2 mb-4">
					@for (i of [0,1,2]; track i) {
						<input
							type="text"
							inputmode="numeric"
							[maxlength]="i === 0 ? 6 : 1"
							[autocomplete]="i === 0 ? 'one-time-code' : 'off'"
							class="otp-box-modal"
							placeholder="0"
							[id]="'otp-gate-' + i"
							[ngModel]="otpDigits()[i]"
							(input)="onOtpInput(i, $event)"
							(keydown)="onOtpKeydown(i, $event)"
							(paste)="onOtpPaste($event)" />
					}
					<span class="mx-1" style="font-size: 32px; color: #d1d5db; font-weight: 300;">-</span>
					@for (i of [3,4,5]; track i) {
						<input
							type="text"
							inputmode="numeric"
							maxlength="1"
							autocomplete="off"
							class="otp-box-modal"
							placeholder="0"
							[id]="'otp-gate-' + i"
							[ngModel]="otpDigits()[i]"
							(input)="onOtpInput(i, $event)"
							(keydown)="onOtpKeydown(i, $event)"
							(paste)="onOtpPaste($event)" />
					}
				</div>

				<div class="text-center mb-4">
					<p class="text-muted small mb-1">Tempo rimasto: {{ timerDisplay() }}</p>
					@if (timerValue() === 0) {
						<a href="javascript:void(0)" class="text-primary fw-bold small text-decoration-none" (click)="resendOtp()">
							Clicca qui per richiedere un nuovo codice OTP
						</a>
					}
				</div>

				@if (errorMsg()) {
					<div class="d-flex align-items-center gap-2 p-3 mb-3 rounded-3" style="background:#FDEDEC; color: #E74C3C;">
						<i class="bi bi-exclamation-circle-fill"></i>
						<span>{{ errorMsg() }}</span>
					</div>
				}

				<div class="d-flex flex-column gap-3 align-items-center mt-2">
					<button
						class="btn btn-kf-primary w-100 py-3 fw-bold shadow-sm"
						style="text-transform: uppercase; letter-spacing: 1px;"
						(click)="conferma()"
						[disabled]="!isOtpComplete() || loadingAction()">
						@if (loadingAction()) {
							<span class="spinner-border spinner-border-sm me-2"></span>
						}
						AUTENTICATI
					</button>
				</div>

			</div>
		</div>
	}

</div>
